export default __webpack_public_path__ + "c5e8e35fe22635c97a95ebd42e1f258a.svg";